export const showPassengerSelector = ({
  is_external,
  is_seat_selection_first_enabled,
  is_vehicle_available,
  is_roundtrip,
  cart_id
}: {
  is_external?: boolean;
  is_seat_selection_first_enabled: boolean;
  is_vehicle_available: boolean | undefined;
  is_roundtrip: boolean;
  cart_id: string | null;
}): boolean => {
  // We dont't show the passenger selector on roundtrip outbound ticket options page. It is displayed on the roundtrip return ticket options page.
  const is_roundtrip_outbound = is_roundtrip && !cart_id;

  return (
    is_seat_selection_first_enabled &&
    !is_external &&
    // is_vehicle_available is undefined when the seat selection is not ready yet, but not necessarily false
    is_vehicle_available === false &&
    !is_roundtrip_outbound
  );
};
